import Vue from "vue";

export const getBluePrintingLevel = ({ dispatch }, id) => {
  Vue.http.get("api/v1/BPL").then(function (response) {
    dispatch("BPL_LOADED", response.data);
  });
};

export const setBluePrintingLevel = ({ dispatch }, bpl) => {
  Vue.http.post("api/v1/BPL", bpl).then(function (response) {
    dispatch("BPL_SET", bpl);
  });
};

export const changeCompany = ({ dispatch }, companyId) => {
  Vue.http.get("api/v1/BPL", {companyId: companyId}).then(function (response) {
    dispatch("BPL_COMPANY_CHANGED", response.data);
  });
};

export const changeArchiveMode = ({ dispatch }, isArchive) => {
  dispatch("ARCHIVE_MODE_CHANGED", isArchive);
};



// WEBPACK FOOTER //
// ./src/shared/bpl/BluePrintingLevelActions.js